<template>
    <section class="p-[16px]">
        <div class="mb-[16px]">
            <h2 class="text-[18px] text-[#2b2b2b] font-light">Liste des départements</h2>
        </div>

        <div class=" mb-[16px] text-[#2b2b2b]">
            <h3 class="text-2xl underline">Ajouter un département</h3>
            <form @submit.prevent="addDepartement" class="flex items-end gap-x-3 justify-between mt-3">
                <div class="grow flex flex-col items-start ">
                    <label for="Libelle" class="font-light" >Libelle<span class="text-[#f44545]">*</span></label>
                    <input type="text" placeholder="HR" v-model="name" name="Libelle" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>

                <button type="submit" class="py-4 rounded-md w-[250px] text-white bg-[#5357ec]">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                    <span v-if="!asSend">Enregistrer</span>
                </button>
            </form>
        </div>


        <div class="text-[#2b2b2b]">
            <h3 class="text-2xl underline">Liste des départements</h3>

            <CustomTable class="mt-[8px]" :data="departement" :columnsCustom="columnn" :load="table_load">
                <template #other-filter>
                    <div class="flex items-center gap-x-[8px] justify-between">
                        <button v-on:click="getAllDepartement('refresh')" :disabled="table_load" class="size-[35px] border rounded-xl flex items-center justify-center">
                            <RefreshCw color="#2b2b2b" :size="16" strokeWidth="1.3" :class="{'animate-spin':actu_load}"/>
                        </button>
                    </div>
                </template>
                <template #row-cell="slotProps">
                    <span v-if="slotProps.cellNumber == 1">
                        {{ slotProps.value }}
                    </span>
                    <span v-else-if="slotProps.cellNumber == 2" class="flex items-center gap-x-[16px] text-black">
                        <button v-on:click="updateDepartement(slotProps.value)"
                        class="border rounded-xl h-[35px] px-6 flex items-center gap-x-[12px]"><Check color="#000" :size="16" strokeWidth="1.3"/> Modifier</button>
                        <button v-on:click="removeDepartement(slotProps.value.id)"
                        class="text-[#ee4636] border rounded-xl h-[35px] px-6 flex items-center gap-x-[12px]"><X color="#ee4636" :size="16" strokeWidth="1.3"/> Rejeter</button>
                    </span>
                    <span v-else>{{ slotProps.value }}</span>
                </template>
            </CustomTable>
        </div>
    </section>
</template>

<script>
import API from "../../service/API.js";
import Swal from "sweetalert2";
import CustomTable from "@/components/tables/Custom-table.vue";
import {createColumnHelper} from "@tanstack/vue-table";
import {
    Loader2,RefreshCw,Check,X
} from "lucide-vue-next";


const columnHelper = createColumnHelper();
const columnsRequest = [
  columnHelper.accessor(row => row.id, {
    id: 'id',
    header: 'Id',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.name, {
    id: 'label',
    header: 'Libelle',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row, {
    id: 'action',
    header: 'Action',
    cell: info => info.getValue(),
  })
];
export default {
    name: 'DepartementCom',
    components: {
        Loader2,
        CustomTable,RefreshCw,Check,X
    },
    data() {
        return {
            departement: [],
            name: null,
            table_load: true,
            asSend:false,
            columnn: columnsRequest,
            actu_load: false,
        }
    },
    mounted() {
        this.getAllDepartement()
    },
    methods: {
        getAllDepartement(type = null){
            this.table_load = true;
            if(type == 'refresh') this.actu_load = true;
            API.get("departements")
            .then((res)=>{
                if (!res.data.status) throw Error(res.data.message);
                this.departement = res.data.data;
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{
                this.table_load = false;
                if(type == 'refresh') this.actu_load = false;
            });
        },
        addDepartement(){
            this.asSend = true;
            API.post("departements",{
                name: this.name
            }).then((res)=>{
                if (!res.data.status) throw Error(res.data.message);
                    this.name = "";
                    this.getAllDepartement()
                    Swal.fire('Succès !','Département enregistré','success'); 
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{this.asSend = false});
        },
        removeDepartement(id){
            API.delete("departements/"+id)
            .then((res)=>{
                if (!res.data.status) throw Error(res.data.message);
                    this.getAllDepartement()
                    Swal.fire('Succès !','Département supprimer','success'); 
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'));
        },
        async updateDepartement(value){
            const inputValue = value.name;
            const {value: label} = await Swal.fire({
                title: "Modifier le label",
                input: "text",
                inputLabel: "Le label",
                inputValue,
                showCancelButton: true,
                inputValidator: (value) => {
                    if (!value) {
                    return "Vous devez écrire quelque chose";
                    }
                }
            })
            if(label == inputValue) return;
            API.put("departements/"+value.id,{name:label})
            .then((res)=>{
                if (!res.data.status) throw Error(res.data.message);
                    this.getAllDepartement()
                    Swal.fire('Succès !','Département modifié','success');  
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'));
        },
    }
}

</script>